/**
 * SELECTION
 */
export const SELECTION_LOAD = 'SELECTION_LOAD';
/**
 * FAMILY
 */
export const FAMILY_LOAD = 'FAMILY_LOAD';
/**
* CONFIG
*/
export const CONFIG_LOAD = 'CONFIG_LOAD';
/**
 * COVERAGES
 */
export const COVERAGES_LOAD = 'COVERAGES_LOAD';
export const COVERAGES_UPDATE = 'COVERAGES_UPDATE';
export const COVERAGES_HISTORY_LOAD = 'COVERAGES_HISTORY_LOAD';
/**
 * LEAVE BARTER
 */
export const LEAVEBARTER_UPDATE = 'LEAVEBARTER_UPDATE';
